/* 
 *   Created by SGiri 02/14/2018
 */

import { Component, OnInit, ViewChild, Inject, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../util/common.service';
import { UserService, ModalService } from '../auth/services';
import { SignInComponent } from '~auth/components';
import { Observable } from 'rxjs/Observable';
import { UserProfile, User } from '~auth/model';
import { SSO_TOKEN_NAME } from '~auth/providers/auth.provider';
import { STORAGE } from '~auth/providers';
import { AdminService } from '../bi-admin/services/admin.service';
import { environment } from '~environment'

declare var $: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  entryComponents: [SignInComponent]
})
export class NavbarComponent implements OnInit {

  environment: string;
  environments: string[];
  userProfile: Observable<UserProfile>;
  user: User;
  isExpanded: Boolean = false;
  showProfileMenu: Boolean = false;

  @Output() appButtonClicked = new EventEmitter<boolean>();
  @ViewChild(SignInComponent) loginComponent: SignInComponent;

  constructor(private service: CommonService, private userService: UserService, private modalService: ModalService, private adminService: AdminService,
    @Inject(STORAGE) private storage: Storage, @Inject(SSO_TOKEN_NAME) private tokenName: string) {
    this.userProfile = this.userService.getUser();
    this.setEnvironments();
  }

  ngOnInit() {

    let token = this.tokenName + 'Profile'

    this.userProfile.subscribe(user => {
      this.user = <User>user;
      if (!this.user && this.storage.getItem(token)) {
        this.user = <User>JSON.parse(this.storage.getItem(token));
      }

      //set user role for edit restriction
      this.adminService.setUserRole();

    })

    $('body').click(e => {
      let logout = $('#raul-header-user-angle');
      if (!logout.is(e.target)) {
        this.showProfileMenu = false;
        $('#raul-user-context').slideUp();
      }
    })

  }

  setEnv(environment) {

    if (this.environment !== environment) {
      this.environment = environment;
      this.service.setEnvironment(this.environment);
      this.service.reload();
    }
  }

  signIn() {
    this.modalService.getModalComponent(SignInComponent);
  }

  signOut() {
    this.userService.signOut()
      .take(1)
      .subscribe(() => {
        this.modalService.getModalComponent(SignInComponent)
      });
  }

  setEnvironments() {
    if (environment.production) {
      this.environments = ['UAT', 'DEMO', 'PROD', 'UKPROD'];
      this.environment = 'UAT';
    } else {
      this.environments = ['DEV', 'SAT', 'QA'];
      this.environment = 'DEV';
    }
  }

  changeLeftNav() {
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded) {
      this.appButtonClicked.emit(true);
    } else {
      this.appButtonClicked.emit(false);
    }
  }

  userProfileMenu() {
    this.showProfileMenu = !this.showProfileMenu;
    if (this.showProfileMenu) {
      $('#raul-user-context').slideDown();
    } else {
      $('#raul-user-context').slideUp();
    }
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/navbar/navbar.component.ts